import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const UserContext = createContext();

export const UserProvider = ({ children, interfaceLang, courseLang }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [user, setUser] = useState(null);
  const [userProgress, setUserProgress] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      axios.get(`${API_URL}/cours/api/user/`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        setUser(response.data);  // Mettre à jour l'utilisateur
      })
      .catch(error => {
        console.error("Erreur lors de la récupération des informations utilisateur :", error);
      });


      // Récupérer la progression utilisateur
      console.log("langue des cours UserContext : " + courseLang)
      if (courseLang) {
        console.log("Langue des cours UserContext :", courseLang); // Pour debug
        axios.get(`${API_URL}/cours/api/user-progress/?course_language=${courseLang}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(response => setUserProgress(response.data))
          .catch(error => console.error('Erreur lors de la récupération de la progression utilisateur :', error));
      }
      else {
        axios.get(`${API_URL}/cours/api/user-general-progress/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
          .then(response => setUserProgress(response.data))
          .catch(error => console.error('Erreur lors de la récupération de la progression utilisateur :', error));
      }
    }
  }, [courseLang]);

  return (
    <UserContext.Provider value={{ user, setUser, userProgress, setUserProgress }}>
      {children}
    </UserContext.Provider>
  );
};
